<template>
  <div>
    <div v-if="!(isAdmin || isSectorManager) && adv.is_digital"
         class="columns is-gapless is-border-top is-border-bottom has-bg-white is-border-left is-border-right is-min-height-50 is-flex">
      <div class="column is-self-centered is-padding-right is-padding-left">
        <div class="is-self-centered">
          <span class="is-uppercase title is-6">Procédure Dématérialisée</span>
        </div>
      </div>
    </div>
    <div v-if="isAdmin || isSectorManager"
         class="columns is-gapless is-padding-left-small is-padding-right-small is-vcentered is-min-height-50"
         :class="!adv.is_digital ? 'is-border-top has-bg-light is-border-left is-border-right ' : 'has-bg-dark'">
      <div class="column is-narrow">
        <div class="is-padding-top-xsmall is-padding-bottom-xsmall"
             data-tooltip="Option non activée" :class="{'tooltip is-tolltip-bottom': !digitalSignatureEnabled}">
          <div class="">
            <input v-if="inProcess" id="is_digital" v-model="adv.is_digital" :disabled="!digitalSignatureEnabled"
                   @click="procedureEnCours"
                   name="is_digital" class="switch is-success is-rounded" type="checkbox">
            <input v-else id="is_digital" v-model="adv.is_digital" :disabled="!digitalSignatureEnabled"
                   @input="updateAdvDigital()" name="is_digital"
                   class="switch is-success is-rounded" type="checkbox">
            <label for="is_digital" style="font-size: 12.5px" :class="!adv.is_digital ? '' : 'has-text-white'"
                   class="is-uppercase">Procédure Dématérialisée</label>
          </div>
        </div>
      </div>
    </div>
    <div v-if="reminder && !isLoadingReminders && (isAdmin || isSectorManager)"
         class="columns is-gapless is-border-bottom has-bg-white is-border-left is-border-right">
      <div class="column is-self-centered is-padding-left is-padding-right has-text-right">
        <div class="has-text-danger is-size-6">Rappel : Le <b> {{reminder.date | dateReminder}} </b> - Création : <b
                v-if="'is_automatic' in reminder && reminder.is_automatic">Automatique</b><b v-else>Manuel</b> -
          Destinataire : <b>{{reminder.user_name}}</b>
          <a class="has-text-danger is-underline is-italic" @click.prevent.stop="openReminder">(Modifier)</a>
        </div>
      </div>
      <div class="column is-narrow has-bg-danger is-flex is-padding-small">
        <span class="icon has-text-white is-self-centered"><i class="fas fa-alarm-clock"></i></span>
      </div>
    </div>
    <template v-if="!adv.is_digital">
      <div class="is-border is-margin-bottom-xxsmall">
        <div class="columns is-gapless has-bg-white is-border-bottom is-padding">
          <div class="column is-narrow is-padding-right">
            <div class="has-badgeCustom--topright has-badgeCustom--out-quarter">
              <i class="fal fa-6x fa-file-contract"></i>
            </div>
          </div>
          <div class="column is-self-centered is-padding-top-small" :class="{'has-content-disabled' : !(isAdmin || isSectorManager)}">
            <r-label label="Date de signature contrat de réservation" :is-required="false"
                     :value="signatureDate"></r-label>
            <div class="row-width-actions-bar is-border">
              <div class="columns is-gapless is-multiline">
                <div class="column has-bg-white-bis is-flex">
                  <div class="field has-addons is-margin-left-xxsmall is-margin-right-xsmall is-self-centered w100">
                    <div class="control">
                      <a class="button is-static is-border is-square">
                        <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                      </a>
                    </div>
                    <div class="control is-expanded">
                      <flat-pickr @input="update()" :config="configDate" type="date" :disabled="!(isAdmin || isSectorManager)"
                                  class="input is-padding-left-xxsmall is-padding-right-xxsmall"
                                  v-model="signatureDate"></flat-pickr>
                    </div>
                    <div class="control">
                      <a class="button is-grey is-inverted is-border is-min-width-0 is-square"
                         :disabled="!(isAdmin || isSectorManager)"
                         @click="signatureDate = null">
                        <i class="fas fa-times"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div
                        class="column is-narrow is-4-fullhd is-padding-left-small is-padding-right-small is-self-centered columns is-gapless is-vcentered">
                  <div class="column is-narrow">
                    <div class="is-flex dot is-medium has-text-white is-margin-right-small"
                         :class="documentIsValid ? 'has-bg-success' : 'is-border'"
                    >
                      <i class="fal fa-check is-size-6" v-if="documentIsValid"></i>
                    </div>
                  </div>
                  <div class="column"><span class="is-size-6">Contrat signé</span></div>
                </div>
                <div v-if="!documentIsValid" class="column is-12 is-3-widescreen is-narrow is-border-left">
                  <!--<button class="page-header-btn is-small is-grey-dark"><span class="is-size-7">Lier un document</span></button>-->
                  <div class="file" :class="{'has-content-disabled' : !(isAdmin || isSectorManager)}">
                    <label class="w100">
                      <input :class="{'disabled' : !(isAdmin || isSectorManager)}" class="file-input" type="file"
                             accept='image/png, image/jpeg, .pdf'
                             @change="fileChange($event.target.files)" name="resume">
                      <span class="page-header-btn is-small is-grey-dark is-fullwidth">
                      <span v-if='!loadingDoc' class="">Lier un document</span>
                      <span v-else class=""><i class="icon fas fa-spinner fa-spin is-margin-xsmall"></i></span>
                    </span>
                    </label>
                  </div>
                </div>
                <template v-else>
                  <div class="is-border-left">
                    <button class="page-header-btn is-small is-square tooltip is-tooltip-top" @click="download()"
                            data-tooltip="Télécharger document lié"><span
                            class="icon is-size-4"><i class="fal fa-download"></i></span></button>
                  </div>
                  <div class="is-border-left">
                    <button class="page-header-btn is-small is-square tooltip is-tooltip-top" @click="unlink()"
                            data-tooltip="Supprimer document lié"><span
                            class="icon is-size-4"><i class="fal fa-unlink"></i></span></button>
                  </div>
                </template>
              </div>
            </div>
            <div class="is-margin-top-small">
              <span class="is-uppercase is-size-7">DATE INFORMATIQUE DE Passage du lot en ADV : <b>Le {{createdAdv}}</b></span>
            </div>
          </div>
        </div>
        <div v-if="(isAdmin || isSectorManager)"
             class="has-bg-white is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small">
          <span class="is-uppercase title is-6">COURRIER SRU</span>
        </div>
        <div v-if="(isAdmin || isSectorManager) && currentUserCountry === 'FRA'" class="columns is-gapless has-bg-white is-border-top">
          <div class="column is-narrow is-padding-top-small is-padding-bottom-small is-padding-left">
            <div class="has-badgeCustom--topright has-badgeCustom--out-quarter">
              <i class="fal fa-3x fa-file-alt"></i>
            </div>
          </div>
          <div class="column is-self-centered is-padding-left">
            <div class="title is-5"><span
                    class="is-uppercase">{{buyer.last_name}} </span><span>{{buyer.first_name}}</span></div>
          </div>
          <div class="column is-narrow is-self-centered is-padding-top-small is-padding-bottom-small is-padding-right">
            <button @click="openPreview(buyer.pk)"
                    class="button is-small is-light is-border is-transform-none minW140p">
              <span>Voir document (.pdf)</span></button>
          </div>
        </div>
        <template v-for="coBuyer in coBuyers">
          <div v-if="(isAdmin || isSectorManager) && currentUserCountry === 'FRA'" :key="coBuyer.pk" class="columns is-gapless has-bg-white is-border-top">
            <div class="column is-narrow is-padding-top-small is-padding-bottom-small is-padding-left">
              <div class="has-badgeCustom--topright has-badgeCustom--out-quarter">
                <i class="fal fa-3x fa-file-alt"></i>
              </div>
            </div>
            <div class="column is-self-centered is-padding-left">
              <div class="title is-5"><span class="is-uppercase">{{coBuyer.last_name}} </span><span>{{coBuyer.first_name}}</span>
              </div>
            </div>
            <div
                    class="column is-narrow is-self-centered is-padding-top-small is-padding-bottom-small is-padding-right">
              <button @click="openPreview(coBuyer.pk)"
                      class="button is-small is-light is-border is-transform-none minW140p">
                <span>Voir document (.pdf)</span></button>
            </div>
          </div>
        </template>
      </div>

      <div v-if="isAdmin || isSectorManager"
           class="columns is-gapless has-bg-light is-border is-padding-left-small is-padding-right-small is-padding-top-large is-padding-bottom-large">
        <div class="column is-4 is-padding-right-xsmall is-padding-left-xsmall">
          <r-label :label="'DATE D’ENVOI POSTAL DU COURRIER : ' + buyer.last_name + ' ' + buyer.first_name"
                   :is-required="false" :value="signature_sru[0].date_envoi"></r-label>
          <div class="field has-addons">
            <div class="control">
              <a class="button is-static is-border is-square">
                <span class="icon"><i class="fas fa-calendar-alt"></i></span>
              </a>
            </div>
            <div class="control is-expanded has-icons-right">
              <flat-pickr @input="update()" :config="configDateSorti" type="date"
                          class="input is-padding-left-xxsmall is-padding-right-xxsmall"
                          v-model="signature_sru[0].date_envoi"></flat-pickr>
            </div>
            <div class="control">
              <a class="button is-grey is-inverted is-border is-square" @click="signature_sru[0].date_envoi = null">
                <i class="fas fa-times"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="column is-4 is-padding-right-xsmall is-padding-left-xsmall">
          <r-label :label="'Numéro A/R'" :is-required="false" :value="signature_sru[0].numero_ar"></r-label>
          <div class="field has-addons">
            <div class="control">
              <a class="button is-static is-border is-square">
                <span class="icon"><i class="far fa-mail-bulk"></i></span>
              </a>
            </div>
            <div class="control is-expanded has-icons-right">
              <v-input id="ref" name="ref" @input="val => update(val, '0')"
                       :model="signature_sru[0].numero_ar"
                       v-validate="''" :errors-bag="errors" data-vv-value-path="val"
                       data-vv-as="numero a/r" data-type-cy="input" data-value-cy="input_ref">
              </v-input>
            </div>
            <div class="control">
              <a class="button is-grey is-inverted is-border is-square" @click="deleteNumAr('0')">
                <i class="fas fa-times"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="column is-4 s-padding-right-xsmall is-padding-left-xsmall">
          <r-label :label="'DATE DE RÉCEPTION a/r'" :is-required="false"
                   :value="signature_sru[0].date_reception"></r-label>
          <div class="field has-addons">
            <div class="control">
              <a class="button is-static is-border is-square">
                <span class="icon"><i class="fas fa-calendar-alt"></i></span>
              </a>
            </div>
            <div class="control is-expanded has-icons-right">
              <flat-pickr :config="configDateSorti" @input="update()" type="date"
                          class="input is-padding-left-xxsmall is-padding-right-xxsmall"
                          v-model="signature_sru[0].date_reception"></flat-pickr>
            </div>
            <div class="control">
              <a class="button is-grey is-inverted is-border is-square" @click="signature_sru[0].date_reception = null">
                <i class="fas fa-times"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <template v-for="(coBuyer, idx) in coBuyers">
        <div v-if="isAdmin || isSectorManager" :key="coBuyer.pk + idx"
             class="columns is-gapless has-bg-light is-border-left is-border-right is-border-bottom is-padding-left-small is-padding-right-small is-padding-top-large is-padding-bottom-large">
          <div class="column is-4 is-padding-right-xsmall is-padding-left-xsmall">
            <r-label :label="'DATE D’ENVOI POSTAL DU COURRIER : ' + coBuyer.last_name + ' ' + coBuyer.first_name"
                     :is-required="false" :value="signature_sru[idx + 1].date_envoi"></r-label>
            <div class="field has-addons">
              <div class="control">
                <a class="button is-static is-border is-square">
                  <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                </a>
              </div>
              <div class="control is-expanded has-icons-right">
                <flat-pickr :config="configDateSorti" @input="update()" type="date"
                            class="input is-padding-left-xxsmall is-padding-right-xxsmall"
                            v-model="signature_sru[idx + 1].date_envoi"></flat-pickr>
              </div>
              <div class="control">
                <a class="button is-grey is-inverted is-border is-square"
                   @click="signature_sru[idx + 1].date_envoi = null">
                  <i class="fas fa-times"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="column is-4 is-padding-right-xsmall is-padding-left-xsmall">
            <r-label :label="'Numéro A/R'" :is-required="false" :value="signature_sru[idx + 1].numero_ar"></r-label>
            <div class="field has-addons">
              <div class="control">
                <a class="button is-static is-border is-square">
                  <span class="icon"><i class="far fa-mail-bulk"></i></span>
                </a>
              </div>
              <div class="control is-expanded has-icons-right">
                <v-input id="ref" name="ref" @input="val => update(val, idx + 1)"
                         :model="signature_sru[idx + 1].numero_ar"
                         v-validate="''" :errors-bag="errors" data-vv-value-path="val"
                         data-vv-as="numero a/r" data-type-cy="input" data-value-cy="input_ref">
                </v-input>
              </div>
              <div class="control">
                <a class="button is-grey is-inverted is-border is-square" @click="deleteNumAr(idx + 1)">
                  <i class="fas fa-times"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="column is-4 is-padding-right-xsmall is-padding-left-xsmall">
            <r-label :label="'DATE DE RÉCEPTION a/r'" :is-required="false"
                     :value="signature_sru[idx + 1].date_reception"></r-label>
            <div class="field has-addons">
              <div class="control">
                <a class="button is-static is-border is-min-width-0 is-square">
                  <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                </a>
              </div>
              <div class="control is-expanded has-icons-right">
                <flat-pickr :config="configDateSorti" type="date" @input="update()"
                            class="input is-padding-left-xxsmall is-padding-right-xxsmall"
                            v-model="signature_sru[idx + 1].date_reception"></flat-pickr>
              </div>
              <div class="control">
                <a class="button is-grey is-inverted is-border is-min-width-0 is-square"
                   @click="signature_sru[idx + 1].date_reception = null">
                  <i class="fas fa-times"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>
    <!----------------------------------------- DEMAT  ----------------------------------------->
    <template v-else>
      <div v-if="!loadingProcess && !loadingProcessStart">
        <div v-if="!isProcess">
          <div v-if='!canSubmitDossierResa' class="notification is-danger has-text-centered is-marginless">
            <p class="is-uppercase is-size-7 has-text-weight-medium">
              <span class="icon"><i class="fas fa-exclamation-triangle"></i></span>
              Les informations du contrat de réservation sont incomplètes
            </p>
          </div>
          <div v-else class="notification is-success has-text-centered is-marginless">
            <p class="is-uppercase is-size-7">
              <span class="icon"><i class="fas fa-check-square"></i></span>
              <span class="has-text-weight-medium">DOSSIER COMPLET</span>
            </p>
          </div>
          <div class="columns is-centered is-4 is-gapless has-bg-light is-border">
            <div class="column is-flex is-narrow is-padding-top is-padding-left is-padding-bottom">
              <div class="has-badgeCustom--topright has-badgeCustom--out-quarter">
                <i class="fal fa-6x fa-file-pdf"></i>
                <span v-if='!canSubmitDossierResa'
                      class="badgeCustom is-large is-bordered is-danger tooltip is-tooltip-top"
                      data-tooltip="Information manquante">
                  <span class="icon"><i class="fas fa-exclamation"></i></span>
                </span>
                <span v-else class="badgeCustom is-large is-bordered is-success tooltip is-tooltip-top"
                      data-tooltip="Dossier complet">
                  <span class="icon"><i class="fas fa-check"></i></span>
                </span>
              </div>
            </div>
            <div class="column is-self-centered is-narrow is-padding-top is-padding-left is-padding-bottom">
              <div>
                <span class="title is-3" style="font-weight: 500;">Contrat de réservation ADV {{adv.ref}}</span>
              </div>
              <div v-if='!canSubmitDossierResa'>
                <a @click="goToResa()" class="is-size-6 is-underline">Modifier les informations</a>
              </div>
            </div>
          </div>
          <div
                  class="is-padding-left is-padding-right is-padding-top-xsmall is-border-right is-border-left has-bg-white is-padding-bottom-xsmall is-min-height-50 is-flex"
                  :class="!(isAdmin || isSectorManager) || documentChecked ? 'is-border-bottom' : ''">
            <div class="is-self-centered"><span class="is-uppercase is-size-7">Signataires du document</span></div>
          </div>
          <div v-if="!promoteurChecked || !buyerChecked"
               class="notification is-warning has-text-centered is-marginless">
            <p class="is-uppercase is-size-7 has-text-weight-medium">
              <span class="icon has-text-danger is-size-5"><i class="fas fa-exclamation-circle"></i></span>
              Vérifier les informations des différents signataires. Un numéro de téléphone portable valide est
              obligatoire pour le ou les acquéreurs.
            </p>
          </div>
          <div class="has-bg-white">
            <membre-adv @goToContact="goToContact" :is-check="checkCompleteBuyerMxn(buyer)" :membre="buyer"
                        :is-promoteur="false" :is-co-acquereur="false" :modal-promoteur="false"></membre-adv>
            <template v-for="coBuyer in coBuyers">
              <membre-adv @goToContact="goToContact" @DeleteCobuyer="beforeRemove"
                          :is-check="checkCompleteBuyerMxn(coBuyer)" :key="coBuyer.pk" :membre="coBuyer"
                          :is-promoteur="false" :is-co-acquereur="true" :modal-promoteur="false"></membre-adv>
            </template>
            <membre-adv @openModalPromoteurInfo="openModalPromoteurInfo" :is-check="promoteurChecked"
                        :membre="adv.promoteur_contact" :is-promoteur="true" :is-co-acquereur="false"
                        :modal-promoteur="true"></membre-adv>
          </div>
        </div>
        <div v-else>
          <template v-for="(procedure, idx) in procedures">
            <procedure-item :key="idx" :signatures="signature_sru" :source="procedure" @commitAdv="commitAdv"
                            @updateProcedure="updateProcedure"></procedure-item>
          </template>
        </div>
        <div v-if="canSubmitDossierResa && !pendingEdition && !inProcess"
             class="columns is-gapless is-centered has-bg-white is-padding-top-small is-padding-bottom-small">
          <div class="column is-4 is-margin-left-small">
            <a @click="postProcedure()" class="is-min-height-50 button is-success is-transform-none is-fullwidth">
              <div class="veryFastAnimation">
                <span>Lancer la procédure</span>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div v-if="loadingProcess || loadingProcessStart">
        <div v-if="loadingProcess">
          <div v-if='errorProcedure' class="notification is-danger has-text-centered is-marginless">
            <p class="is-uppercase is-size-7">
              <span class="icon has-text-white"><i class="fas fa-exclamation-triangle"></i></span>
              Une Erreur a été détécté :
              <b>
                <span v-if="errorProcedure === 'EMAIL_NOT_VALID'"> l'email</span>
                <span v-if="errorProcedure === 'PHONE_NOT_VALID'">le numéro </span>
                d'un des signataires est erroné.
              </b>
            </p>
          </div>
          <div v-else class="notification is-warning has-text-centered is-marginless">
            <p class="is-uppercase is-size-7">
              Le temps de lancement de la procédure peut prendre jusqu’a 1 minute et est conditonné par le débit de
              votre connexion internet
            </p>
          </div>
          <div class="columns is-border">
            <div class="column is-narrow is-paddingless-right">
              <div class="is-padding-left-large is-padding-right-large">
                <img style="height: 100px;" src="/static/loader-procedure-signature.gif">
              </div>
            </div>
            <div class="column is-narrow">
              <div class="columns is-gapless is-vcentered">
                <div class="column is-narrow">
                  <span class="is-size-3 icon is-padding-right-small"
                        :class="{'has-text-grey-light' : width < 3 && !errorProcedure, 'has-text-success' : width >= 3, 'has-text-danger' : width < 3 && errorProcedure}">
                    <i class="fas fa-check-circle"></i>
                  </span>
                </div>
                <div class="column">
                  <span :class="width > 3 ? '' : 'has-text-grey-light'">
                    Ouverture de la connexion sécurisée au service
                  </span>
                </div>
              </div>
              <div class="columns is-gapless is-vcentered is-margin-top-xsmall">
                <div class="column is-narrow">
                  <span class="is-size-3 icon is-padding-right-small"
                        :class="{'has-text-grey-light' : width < 35 && !errorProcedure, 'has-text-success' : width >= 35, 'has-text-danger' : width < 35 && errorProcedure}">
                  <i class="fas fa-check-circle"></i>
                </span>
                </div>
                <div class="column">
                  <span :class="width > 35 ? '' : 'has-text-grey-light'">
                    Récupération des informations acquéreur(s)
                  </span>
                </div>
              </div>
              <div class="columns is-gapless is-vcentered is-margin-top-xsmall">
                <div class="column is-narrow">
                  <span class="is-size-3 icon is-padding-right-small"
                        :class="{'has-text-grey-light' : width < 65 && !errorProcedure, 'has-text-success' : width >= 65, 'has-text-danger' : width < 65 && errorProcedure}">
                    <i class="fas fa-check-circle"></i>
                  </span>
                </div>
                <div class="column">
                  <span :class="width > 65 ? '' : 'has-text-grey-light'">
                    Compilation des annexes
                  </span>
                </div>
              </div>
              <div class="columns is-gapless is-vcentered is-margin-top-xsmall">
                <div class="column is-narrow">
                  <span class="is-size-3 icon is-padding-right-small"
                        :class="{'has-text-grey-light' : width < 100 && !errorProcedure , 'has-text-success' : width >= 100, 'has-text-danger' : width < 100 && errorProcedure}">
                    <i class="fas fa-check-circle"></i>
                  </span>
                </div>
                <div class="column">
                  <span :class="width === 100 ? '' : 'has-text-grey-light'">
                    Synchronisation et lancement de la procédure
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="column has-bg-white is-border-left is-border-bottom is-border-right">
            <div id="myProgress">
              <div id="myBar"></div>
            </div>
          </div>
          <div v-if="errorProcedure"
               class="columns is-gapless is-centered has-bg-white is-padding-top-small is-padding-bottom-small">
            <div class="column is-4 is-margin-left-small">
              <a @click="stopProcess()" class="is-min-height-50 button is-success is-transform-none is-fullwidth">
                <div class="veryFastAnimation">
                  <span>Modifier informations</span>
                </div>
              </a>
            </div>
          </div>
        </div>
        <spinner-round :isLoading="loadingProcessStart"></spinner-round>
      </div>
    </template>
    <div v-if="!loadingProcess && !loadingProcessStart" class="has-bg-white is-border is-margin-top-xxsmall">
      <div class="row-width-actions-bar columns is-gapless">
        <div class="column is-self-centered is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
          <span class="is-uppercase title is-6">Commentaire</span>
        </div>
        <div class="column is-narrow is-border-left">
          <button class="page-header-btn is-small is-square" @click="openComment = !openComment"><span
                  class="icon is-size-4">
            <i v-if="!openComment" class="fal fa-chevron-down"></i>
            <i v-else class="fal fa-chevron-up"></i>
            </span></button>
        </div>
      </div>
      <template v-if="openComment">
        <div v-if="!openWysi" class="vadDiscussion is-border-top">
          <div
                  class="vadDiscussion--bulle is-size-6 is-min-height-50 vadDiscussion--bulle--has-actions is-cut is-padding-left">
            <div class="content" v-if="(isAdmin || isSectorManager) && adv.signature.comment" v-html="adv.signature.comment"></div>
            <div class="content" v-else-if="!(isAdmin || isSectorManager) && adv.signature.seller_comment"
                 v-html="adv.signature.seller_comment"></div>
            <div class="content" v-else>Aucun commentaire</div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div class="">
                <button @click="openWysiwyg" class="is-min-height-full">
                  <span class="icon is-small"><i class="fal fa-edit"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="is-border-top columns is-gapless">
          <div class="column" v-if="isAdmin || isSectorManager">
            <wysiwyg-editor
                    :light='true' :tooltip-top="true"
                    :model="commentaire"
                    @change="val => commentaire = val"
                    class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
            </wysiwyg-editor>
          </div>
          <div class="column" v-else>
            <wysiwyg-editor
                    :light='true' :tooltip-top="true"
                    :model="seller_commentaire"
                    @change="val => seller_commentaire = val"
                    class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
            </wysiwyg-editor>
          </div>
          <div class="actionsOnRow actionsOnRow--vertical">
            <div>
              <button @click="saveAdv()" type="button" class="button is-success">
                <span class="icon is-small"><i class="fal fa-save"></i></span>
              </button>
            </div>
            <div class="">
              <button type="button" class="actionsOnRow-btn--hoverIsDanger" @click="openWysi = false">
                <span class="icon is-small"><i class="fal fa-times"></i></span>
              </button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import MembreAdv from '../MembreAdv'
  import { AdvMx } from '@/mixins'
  import { bus, EVENTS } from '@/services/bus/index.js'
  import { isEmpty, isNil, cloneDeep, remove } from 'lodash'
  import moment from 'moment'
  import { mapState, mapGetters } from 'vuex'
  import ProcedureItem from './ProcedureItem'

  export default {
    name: 'Signature',
    mixins: [AdvMx],
    components: { ProcedureItem, MembreAdv },
    data () {
      return {
        isLoadingReminders: false,
        reminder: null,
        errorProcedure: null,
        width: 1,
        min: 5,
        max: 0,
        idBar: null,
        finished: false,
        ouverture: false,
        recuperation: false,
        compilation: false,
        synchronisation: false,
        is25: true,
        openComment: true,
        openWysi: false,
        commentaire: null,
        seller_commentaire: null,
        loadingProcess: false,
        loadingProcessStart: false,
        loadingDoc: false,
        procedures: [],
        files: null,
        configDate: {
          altFormat: 'j/m/Y',
          altInput: true,
          dateFormat: 'd/m/Y H:i'
        },
        configDateSorti: {
          altFormat: 'j/m/Y',
          altInput: true,
          dateFormat: 'Z'
        },
        signature_sru: [],
        signatureDate: null,
        contrat_signe: {}
      }
    },
    watch: {
      modal ({ mode, params, results }) {
        if (results) {
          if (mode === 'PROMOTEUR_CONTACT') {
            let adv = Object.assign({}, this.adv)
            this.$set(adv, 'promoteur_contact', results)
            this.$emit('commit', adv)
          }
        }
      }
    },
    computed: {
      ...mapState(['modal', 'configs']),
      ...mapGetters(['currentUserCountry']),
      digitalSignatureEnabled () {
        if ('DIGITAL_SIGNATURE_ENABLED' in this.configs && this.configs.DIGITAL_SIGNATURE_ENABLED) {
          return this.configs.DIGITAL_SIGNATURE_ENABLED.toString() === '1'
        }
        return false
      },
      programChecked () {
        if (!this.program) return
        return (this.program.total_lots !== null && this.program.total_lots !== '') &&
          (this.program.reference_cadrastrale !== null && this.program.reference_cadrastrale !== '') &&
          (this.program.surface_terrain !== null && this.program.surface_terrain !== '') &&
          (this.program.surface_plancher !== null && this.program.surface_plancher !== '') &&
          (this.program.num_pc !== null && this.program.num_pc !== '') &&
          (this.program.total_parking !== null && this.program.total_parking !== '') &&
          (this.program.planned_developments !== null && this.program.planned_developments !== '') &&
          (this.program.construction_licence_author !== null && this.program.construction_licence_author !== '') &&
          (this.program.construction_licence_date !== null && this.program.construction_licence_date !== '') &&
          (this.program.total_buildings !== null && this.program.total_buildings !== '') &&
          (this.program.promoteur_info.rep_first_name !== null && this.program.promoteur_info.rep_first_name !== '') &&
          (this.program.promoteur_info.rep_last_name !== null && this.program.promoteur_info.rep_last_name !== '') &&
          (this.program.promoteur_info.rep_email !== null && this.program.promoteur_info.rep_email !== '') &&
          (this.program.promoteur_info.rep_phone !== null && this.program.promoteur_info.rep_phone !== '') &&
          (this.program.promoteur_info.rep_address !== null && this.program.promoteur_info.rep_address !== '') &&
          (this.program.promoteur_info.rep_address.line1 !== null && this.program.promoteur_info.rep_address.line1 !== '') &&
          (this.program.promoteur_info.rep_address.city !== null && this.program.promoteur_info.rep_address.city !== '') &&
          (this.program.promoteur_info.rep_address.country !== null && this.program.promoteur_info.rep_address.country !== '') &&
          (this.program.promoteur_info.rep_address.zip_code !== null && this.program.promoteur_info.rep_address.zip_code !== '') &&
          (this.program.ref !== null && this.program.ref !== '') &&
          (this.program.notary.email !== null && this.program.notary.email !== '') && (this.program.notary.name !== null && this.program.notary.name !== '') &&
          (this.program.notary.phone !== null && this.program.notary.phone !== '') &&
          (this.program.notary.address !== null && this.program.notary.address !== '') &&
          (this.program.notary.address.line1 !== null && this.program.notary.address.line1 !== '') &&
          (this.program.notary.address.city !== null && this.program.notary.address.city !== '') &&
          (this.program.notary.address.country !== null && this.program.notary.address.country !== '') &&
          (this.program.notary.address.zip_code !== null && this.program.notary.address.zip_code !== '')
      },
      lotChecked () {
        if (!this.lot || !this.adv) return
        if (this.lot.nature === 'parking') {
          return (this.lot.ref !== null && this.lot.ref !== '') &&
            (this.lot.sale_price !== null && this.lot.sale_price !== '') &&
            (this.lot.sale_price_ht !== null && this.lot.sale_price_ht !== '')
        } else if (this.lot.nature === 'field') {
          return (this.adv.sale_price_with_discount !== null && this.adv.sale_price_with_discount !== '')
        } else {
          return (this.lot.floor !== null && this.lot.floor !== '') && (this.lot.surface !== null && this.lot.surface !== '') &&
            (this.lot.lot_type !== null && this.lot.lot_type !== '') &&
            (this.adv.sale_price_with_discount !== null && this.adv.sale_price_with_discount !== '')
        }
      },
      documentChecked () {
        this.contratDeReservationDocuments.forEach(x => {
          if (x.document !== null) {
            if (x.document.cloudinary_id === null && x.document.cloudinary_version === null &&
              x.document.display === null && x.document.filename === null && x.document.fus_id === null && x.document.path === null &&
              x.document.s3_key === null && x.document.s3_path === null) x.document = null
          }
        })
        return !this.contratDeReservationDocuments.find(x => {
          return x.document === null
        })
      },
      buyerChecked () {
        let allBuyers = []
        if (this.coBuyers && this.coBuyers.length) {
          allBuyers = allBuyers.concat(this.coBuyers, this.buyer)
        } else {
          allBuyers.push(this.buyer)
        }
        let checkBuyer = []
        allBuyers.forEach(x => {
          checkBuyer.push(this.checkCompleteBuyerMxn(x))
        })
        return checkBuyer.find(x => {
          if (x === false) return x === false
          return true
        })
      },
      financementChecked () {
        if (!this.adv.use_loan) {
          if (this.adv.security_deposit) {
            return this.adv.security_deposit_value !== null && this.adv.security_deposit_value !== ''
          } else {
            return true
          }
        } else {
          if (this.adv.security_deposit) {
            return this.adv.initial_bank_name !== null && this.adv.initial_bank_name !== '' &&
              this.adv.initial_loan_value !== null && this.adv.initial_loan_value !== '' &&
              this.adv.initial_loan_duration !== null && this.adv.initial_loan_duration !== '' &&
              this.adv.initial_loan_rate !== null && this.adv.initial_loan_rate !== '' &&
              this.adv.security_deposit_value !== null && this.adv.security_deposit_value !== ''
          } else {
            return this.adv.initial_bank_name !== null && this.adv.initial_bank_name !== '' &&
              this.adv.initial_loan_value !== null && this.adv.initial_loan_value !== '' &&
              this.adv.initial_loan_duration !== null && this.adv.initial_loan_duration !== '' &&
              this.adv.initial_loan_rate !== null && this.adv.initial_loan_rate !== ''
          }
        }
      },
      promoteurChecked () {
        if (!this.adv.promoteur_contact) return
        return !isNil(this.adv.promoteur_contact.last_name) && !isNil(this.adv.promoteur_contact.company_name) && !isNil(this.adv.promoteur_contact.first_name) && !isEmpty(this.adv.promoteur_contact.address) &&
          !isNil(this.adv.promoteur_contact.phone) && !isNil(this.adv.promoteur_contact.email)
      },
      canSubmitDossierResa () {
        return this.lotChecked && this.programChecked && this.documentChecked && this.buyerChecked && this.promoteurChecked && this.financementChecked
      },
      isProcess () {
        return this.procedures && this.procedures.length
      },
      inProcess () {
        let active = this.procedures.find(x => {
          return x.status === 'active' || x.status === 'finished'
        })
        return active
      },
      documentIsValid () {
        return this.contrat_signe.cloudinary_id && this.contrat_signe.cloudinary_id
      },
      createdAdv () {
        let day = moment(this.adv.created_on).format('DD/MM/YYYY')
        let time = moment(this.adv.created_on).format('HH:mm')
        return day + ' à ' + time
      }
    },
    methods: {
      beforeRemove (val) {
        this.$swal({
          title: 'Acquéreur',
          text: 'Souhaitez-vous vraiment retirer cet acquéreur ?',
          confirmButtonText: 'Oui',
          cancelButtonText: 'Annuler',
          cancelButtonColor: '#ff0200',
          showCloseButton: true
        }).then(res => {
          console.log(res)
          if (res.value) {
            this.DeleteCobuyer(val)
          }
        })
      },
      stopProcess () {
        this.loadingProcess = false
        this.errorProcedure = false
        this.width = 1
        this.min = 5
        this.max = 0
        this.idBar = null
      },
      openWysiwyg () {
        this.openWysi = true
        this.$nextTick(() => {
          let wysiElem
          if (!this.adv.signature.comment && !this.adv.signature.seller_comment) {
            wysiElem = document.getElementsByClassName('ql-editor ql-blank')
            wysiElem = wysiElem[0]
            wysiElem.setAttribute('contenteditable', 'true')
            wysiElem.focus()
          } else {
            let selection = document.getSelection()
            let range = document.createRange()
            let contenteditable = document.querySelector('div[contenteditable="true"]')

            if (contenteditable.lastChild.nodeType === 3) {
              range.setStart(contenteditable.lastChild, contenteditable.lastChild.length)
            } else {
              range.setStart(contenteditable, contenteditable.childNodes.length)
            }
            selection.removeAllRanges()
            selection.addRange(range)
          }
        })
      },
      checkCompleteBuyerMxn (buyer) {
        if (!buyer) return
        if (buyer.nature === 'corporation') {
          return (buyer.corporation_name !== null || buyer.corporation_name !== '') &&
            (buyer.corporation_siret !== null || buyer.corporation_siret !== '') &&
            buyer.last_name !== null && buyer.last_name !== '' &&
            buyer.first_name !== null && buyer.first_name !== '' &&
            buyer.birth_name !== null && buyer.birth_name !== '' &&
            buyer.address !== null && buyer.address !== '' &&
            buyer.address.line1 !== null && buyer.address.line1 !== '' &&
            buyer.address.zip_code !== null && buyer.address.zip_code !== '' &&
            buyer.address.city !== null && buyer.address.city !== '' &&
            (buyer.csp === 'unemployed' || buyer.csp === 'retirement'
              ? true : buyer.profession !== null && buyer.profession !== '')
        } else {
          return buyer.last_name !== null && buyer.last_name !== '' &&
            buyer.birth_name !== null && buyer.birth_name !== '' &&
            buyer.first_name !== null && buyer.first_name !== '' &&
            buyer.address !== null && buyer.address !== '' &&
            buyer.address.line1 !== null && buyer.address.line1 !== '' &&
            buyer.address.zip_code !== null && buyer.address.zip_code !== '' &&
            buyer.address.city !== null && buyer.address.city !== '' &&
            buyer.birthday !== null && buyer.birthday !== '' &&
            buyer.nationality !== null && buyer.nationality !== '' &&
            buyer.birthplace !== null && buyer.birthplace !== '' &&
            buyer.family_situation !== null && buyer.family_situation !== '' &&
            buyer.income !== null && buyer.income !== '' &&
            buyer.is_owner !== null && buyer.is_owner !== '' &&
            buyer.tax_income !== null && buyer.tax_income !== '' &&
            buyer.land_income !== null && buyer.land_income !== '' &&
            (buyer.csp === 'unemployed' || buyer.csp === 'retirement'
              ? true : buyer.profession !== null && buyer.profession !== '') &&
            (buyer.family_situation === 'married'
              ? (buyer.matrimonial_status !== null && buyer.matrimonial_status !== '') &&
              (buyer.wedding_date !== null && buyer.wedding_date !== '') &&
              (buyer.wedding_place !== null && buyer.wedding_place !== '')
              : true) &&
            (buyer.family_situation === 'pacs'
              ? (buyer.matrimonial_status !== null && buyer.matrimonial_status !== '') &&
              (buyer.wedding_date !== null && buyer.wedding_date !== '') &&
              (buyer.wedding_place !== null && buyer.wedding_place !== '')
              : true)
        }
      },
      saveAdv () {
        let adv = Object.assign({}, this.adv)
        this.$set(adv.signature, 'comment', this.commentaire)
        this.$set(adv.signature, 'seller_comment', this.seller_commentaire)
        this.$emit('saveAdv', adv)
        this.openWysi = false
      },
      unlink () {
        let empty = {
          account: null,
          cloudinary_id: null,
          cloudinary_version: null,
          filename: null,
          fus_id: null,
          id: null,
          path: null
        }
        this.$set(this.adv.signature, 'contrat', empty)
        this.commitAdv()
      },
      download () {
        let link = document.createElement('a')
        link.href = this.adv.signature.contrat.path
        link.target = '_blank'
        link.click()
      },
      openReminder () {
        let params = {
          defaultTitle: this.reminder.title,
          date: moment(this.reminder.date).format('DD/MM/YYYY HH:mm'),
          pk: this.reminder.pk,
          source: this.reminder
        }
        this.$store.commit('setQuickview', { mode: 'EDIT_REMINDER', params })
      },
      procedureEnCours () {
        this.$notify({
          type: 'is-danger',
          text: 'Procedure de signature électronique en cours : annuler la procédure pour faire des modifications '
        })
      },
      updateProcedure (procedure) {
        let idx = this.procedures.findIndex(x => {
          return x.pk === procedure.pk
        })
        if (idx >= 0) {
          this.procedures.splice(idx, 1, procedure)
        }
      },
      updateAdvDigital () {
        this.$emit('commit', this.adv)
      },
      DeleteCobuyer (buyer) {
        remove(this.coBuyers, x => x.pk === buyer.pk)
        let adv = cloneDeep(this.adv)
        adv.co_buyers = this.coBuyers.length ? this.coBuyers.map(x => x.pk) : []
        this.$emit('commit', adv)
      },
      fileChange (files) {
        this.loading = false
        this.uploaded = false
        for (let i = 0; i < files.length; i++) {
          let file = files[i]
          this.files.append('file[]', file, file.name)
        }
        this.upload()
      },
      async upload (e = null) {
        let files
        if (e !== null) files = e
        else files = this.files
        this.loadingDoc = true
        let config = {
          onUploadProgress: progressEvent => {
            this.progressData = Math.floor((progressEvent.loaded * 100) / progressEvent.total)
          }
        }
        try {
          let res = await this.$fus.post({ data: files, config })
          let hostedFiles = res.data.slice()
          hostedFiles = hostedFiles.map(x => {
            return {
              fus_id: x.id,
              cloudinary_id: x.cloudinary_id,
              cloudinary_version: x.cloudinary_version,
              path: x.path,
              filename: x.filename,
              display: x.display || true
            }
          })
          this.loadingDoc = false
          this.uploadDocument(hostedFiles)
        } catch (e) {
          this.loadingDoc = false
          console.log(e)
        }
      },
      uploadDocument (data) {
        this.contrat_signe = data[0]
        let adv = Object.assign([], this.adv)
        this.$set(adv.signature, 'contrat', data[0])
        this.$emit('commit', adv, false)
        this.$notify({
          type: 'is-success',
          text: 'Le document à été téléchargé avec succès'
        })
      },
      goToResa () {
        this.$emit('goToResa')
      },
      openPreview (buyerPk) {
        let params = {
          idBuyer: buyerPk,
          idAdv: this.adv.pk
        }
        this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW', params })
      },
      update (value, elem) {
        if (value && elem) {
          this.$set(this.signature_sru[elem], 'numero_ar', value)
        } else if (value === '' && elem) {
          this.$set(this.signature_sru[elem], 'numero_ar', null)
        }
        this.$nextTick(() => {
          this.commitAdv()
        })
      },
      deleteNumAr (elem) {
        this.signature_sru[elem].numero_ar = null
        this.commitAdv()
      },
      commitAdv () {
        let adv = Object.assign([], this.adv)
        adv.signature.sru_list = this.signature_sru.map(x => Object.assign({}, x))
        for (let item of adv.signature.sru_list) {
          if (item.date_envoi) {
            item.date_envoi = (new Date(item.date_envoi)).toUTCString()
          }
          if (item.date_reception) {
            item.date_reception = (new Date(item.date_reception)).toUTCString()
          }
        }
        this.$set(adv, 'signature_date', this.signatureDate)
        this.$emit('commit', adv, false)
      },
      getProcedureList () {
        this.loadingProcessStart = true
        this.$api.advService.getProcedureList(this.advPk).then(res => {
          this.loadingProcessStart = false
          this.procedures = res.data
        }).catch(err => {
          this.loadingProcessStart = false
          console.log(err)
        })
      },
      getProcedure (procedurePk) {
        let index = this.procedures.findIndex(x => x.pk === procedurePk)
        this.$api.advService.getProcedure(this.advPk, procedurePk).then(res => {
          if (index < 0) {
            this.procedures.push(res.data)
          } else {
            this.$set(this.procedures, index, res.data)
          }
          this.width = 1
          this.idBar = null
        })
      },
      postProcedure () {
        this.loadingProcess = true
        this.$api.advService.postProcedure(this.advPk).then(res => {
          this.progressBar()
        }).catch(err => {
          console.log(err)
          this.loadingProcess = false
        })
      },
      progressBar () {
        let rand = Math.floor(Math.random() * (this.max - this.min + 1) + this.min)
        this.idBar = setTimeout(this.frame, rand * 100)
      },
      frame () {
        if (this.width >= 89 || this.errorProcedure) {
          clearTimeout(this.idBar)
        } else {
          this.width++
          let newRand = Math.floor(Math.random() * (this.max - this.min + 1) + this.min)
          var elem = document.getElementById('myBar')
          elem.style.width = this.width + '%'
          this.idBar = setTimeout(this.frame, newRand * 100)
        }
      },
      loadReminders () {
        this.reminder = null
        this.isLoadingReminders = true
        let params = {
          custom_fields__code: 'signingRequiredAutoReminder',
          custom_fields__adv: this.advPk,
          user: this.currentUserPk
        }
        this.$api.reminderService.get(params).then(r => {
          if (r.data.items) {
            this.reminder = r.data.items[0]
            this.isLoadingReminders = false
          }
        })
      }
    },
    created () {
      this.loadReminders()
      if (this.adv.signature.comment) this.commentaire = this.adv.signature.comment
      if (this.adv.signature.seller_comment) this.seller_commentaire = this.adv.signature.seller_comment
      this.getProcedureList()
      this.files = new FormData()
      this.signature_sru = this.adv.signature.sru_list.map(x => Object.assign({}, x))
      for (let item of this.signature_sru) {
        if (item.date_envoi) {
          item.date_envoi = moment(item.date_envoi).format('DD/MM/YYYY HH:mm')
        }
        if (item.date_reception) {
          item.date_reception = moment(item.date_reception).format('DD/MM/YYYY HH:mm')
        }
      }
      this.signature_sru = this.adv.signature.sru_list
      this.signatureDate = moment(this.adv.signature_date).format('DD/MM/YYYY HH:mm')
      this.contrat_signe = this.adv.signature.contrat
      if (this.$route.params.from && this.$route.params.from === 'modal') {
        if (!this.adv.is_digital) {
          this.adv.is_digital = true
          this.updateAdvDigital()
        }
      }
      bus.$on(EVENTS.UPDATE_ADV_PROCEDURE, ({ adv, procedure, status }) => {
        if (adv === this.advPk) {
          this.getProcedure(procedure)
        }
      })
      bus.$on(EVENTS.ADV_PROCEDURE_ERROR, ({ adv, error }) => {
        console.log(error)
        if (adv === this.advPk) {
          this.errorProcedure = error
          var elem = document.getElementById('myBar')
          elem.classList.add('error')
          console.log(this.errorProcedure)
          // this.getProcedure(procedure)
        }
      })
      bus.$on(EVENTS.NEW_ADV_PROCEDURE, ({ adv, procedure }) => {
        if (adv === this.advPk) {
          var elem = document.getElementById('myBar')
          elem.style.width = 100 + '%'
          this.width = 100
          setTimeout(() => {
            this.getProcedure(procedure)
            this.loadingProcess = false
            this.$notify({
              type: 'is-success',
              text: 'Procedure lancée : un email est envoyé au premier réservataire'
            })
          }, 500)
        }
      })
      bus.$on([EVENTS.NEW_REMINDER, EVENTS.UPDATE_REMINDER], (reminder) => {
        if (reminder.pk === this.reminder.pk) {
          this.loadReminders()
        }
      })
      bus.$on(EVENTS.DELETE_REMINDER, (reminder) => {
        if (reminder.pk === this.reminder.pk) this.reminder = null
      })
    },
    destroyed () {
      bus.$off([EVENTS.NEW_ADV_PROCEDURE, EVENTS.ADV_PROCEDURE_ERROR, EVENTS.UPDATE_ADV_PROCEDURE, EVENTS.NEW_REMINDER, EVENTS.UPDATE_REMINDER, EVENTS.DELETE_REMINDER])
    }
  }
</script>

<style>
  #myProgress {
    width: 100%;
    background-color: #ddd;
  }

  #myBar {
    width: 1%;
    height: 15px;
    background-color: #80bc74;
  }

  .error {
    background-color: #db534d !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/adv/FeuilleDeRoute/Signature.vue